<template>
    <div class='order-contract'>
        <div class="content">
            <iframe ref="contractIframe" :src="authUrl" @error="handleIframeError" scrolling="true" frameborder="0" class="frame"></iframe>
        </div>
        <!-- <button class='btn-back' @click="goback">返回「我的」</button> -->
    </div>
</template>
<script>

import { getHousingAuthUrl } from "@api/user";

export default {
    name: "HousingAuth",
    components: {
    },
    props: {},
    data: function () {
        return {
            authUrl: '',
        };
    },
    mounted: function () {
        window.addEventListener('message', this.handleMessage); 
        this.getHousingAuthUrl();
    },
    beforeDestroy() {
        // 组件销毁前移除监听器，防止内存泄漏
        window.removeEventListener('message', this.handleMessage);
    },
    methods: {
        getHousingAuthUrl(){
            this.$dialog.loading.open("正在加载中");
            let that = this;
            getHousingAuthUrl().then(res => {
                that.$dialog.loading.close();
                that.authUrl = res.data.authUrl;
            }).catch(err => {
                that.$dialog.loading.close();
                that.$dialog.error(err.msg || "数据加载失败", { timeout : 2500 });
                setTimeout(() => {
                    that.$router.go(-1);
                }, 2500);
            })
        },

        handleIframeError() {
            this.$dialog.error('链接打开失败！');
        },

        // 处理接收到的消息
        handleMessage(event) {
            const receivedDataString = event.data;
            let receivedData;
            if(this.isString(receivedDataString)) {
                receivedData = JSON.parse(receivedDataString);
            } else {
                receivedData = receivedDataString;
            }
            if(receivedData.code !== 100000) {
                return;
            }
            this.$dialog.confirm({
                mes: "数据存在延迟，稍后再刷新",
                title: receivedData.msg,
                opts: [
                    {
                        txt: "返回",
                        color: false,
                        callback: () => {
                            this.$router.go(-1);
                         }
                    },
                    {
                        txt: "去首页",
                        color: true,
                        callback: () => {
                            this.$router.replace({ path: '/' });
                        }
                    }
                ]
            });
        },

        goback(){
            this.$router.replace({ path: '/user' });
        },

        isString(value) {
            return typeof value === 'string' || value instanceof String || Object.prototype.toString.call(value) === '[object String]';
        }
    }
};
</script>
<style>
.order-contract {
  background-color: #fff;
  width: 100%;
  height: 100%;
}

.order-contract .content {
    background-color: #f5f5f5;
    width: 100%;
    height: 100%;
}

.order-contract .content .frame {
  width: 100%;
  height: 100%;
}

.order-contract .btn-back {
  position: fixed;
  bottom: 25px;
  left: 80%;
  transform: translateX(-50%);
  z-index: 1000;
  background-color: rgba(233, 51, 35, 0.7);
  color: white;
  padding: 6px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-width: 120px;
  justify-content: center;
}

</style>

